
import { Container } from '@mui/material'
import HeaderSession from '../utils/headerSession'
import RegisterAccess from '../utils/registerAccess'
import { useEffect, useState } from 'react'
import api from '../services/api'
import Loading from '../load/loading'
import CardOpcoes from '../utils/cardOpcoes'

export default function ListaPublicaEstabelecimentoCategorias() {
    const [loading, setLoading] = useState(false);
    const [tipo, setTipo] = useState([]);

    useEffect(() => {
        setLoading(true)
        api.get(`/tipo-estabelecimentos`)
            .then(response => {
                setTipo(response.data.tipoEstabelecimentos)
            }).catch(err => { }).
            finally(() => { setLoading(false) })

    }, []);

    return (
        <Container style={{ minHeight: '73vh', }}>
            <RegisterAccess page={'Selecionar Categoria'} />
            <HeaderSession title={'SELECIONAR CATEGORIA'} />

            <div style={{ padding: 20, display: 'flex', gap: '10px', flexDirection: 'column' }}>
                {tipo.map((categoria) => (
                    <CardOpcoes disabled={false} nomeService={categoria?.designacao} link={`/estabelecimentos-licenciados-armed/${categoria?._id}?d=${categoria?.designacao}`} />
                ))}

                {loading && <Loading text={'Lista Actualizada de Categorias.'} />}
            </div>

        </Container>
    )
}
